import { NotFoundError } from 'utils/errors';

export class VerticalUnsupportedError extends NotFoundError {}
